exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Navigation_desktop_14kn {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n\n  .Navigation_desktop_14kn {\n    display: block;\n  }\n}\n\n.Navigation_link_3X5Y {\n  margin: 15px 0\n}\n\n.Navigation_link_3X5Y:first-child {\n  margin-top: 0;\n}\n\n.Navigation_link_3X5Y:last-child {\n  margin-bottom: 0;\n}\n\n.Navigation_badge_3YYM {\n  margin-left: 4px;\n  padding: 2px 4px;\n\n  font-size: 10px;\n  font-weight: bold;\n\n  color: #fff;\n  border-radius: 3px;\n  background-color: #5e9929;\n}\n\n@media (min-width: 1024px) {\n\n  .Navigation_mobile_2wlR {\n    display: none;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "Navigation_desktop_14kn",
	"link": "Navigation_link_3X5Y",
	"badge": "Navigation_badge_3YYM",
	"mobile": "Navigation_mobile_2wlR"
};